//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { mapActions } from "vuex";

export default {
    name: "FileScanningService",
    components: {
        AQModal,
        AQInput,
        AQDialog,
        AQButton
    },
    props: {
        extraData: { type: Object,
            default: () => {} },
        enabled: { type: Boolean, default: false },
        fileId: { type: String, default: "" }
    },

    data() {
        return {
            addService: false,
            scanningService: {
                serviceName: "",
                passKey: ""
            },
            scanningServiceCopy: null,
            serviceConfiguration: null,
            serviceConfigurationCopy: null,
            showDialogRemove: false,
            showName: false,
            requiredFields: {},
            serviceNameErrMsg: this.$t("admin.labs.scanningService.serviceNameErrMsg"),
            saveDisabled: true,
            serviceNameErr: false,
            editMode: false,
            warningDialog: false
        };
    },
    computed: {
        hasSave() {
            return {
                label: this.$t("admin.messagingCom.save"),
                disabled: this.saveDisabled && !this.editMode
            };
        },
        modalTitle() {
            return this.editMode ? this.$t("admin.labs.scanningService.editTitle") : this.$t("admin.labs.scanningService.title");
        },
        fileServiceName() {
            return this.extraData && this.extraData.fileScanning ? this.extraData.fileScanning.serviceName : this.scanningService.serviceName;
            
        },
        configDisabled() {
            return !(this.scanningService.serviceName && this.scanningService.passKey);
        }

    },

    mounted() {
        this.addService = !this.extraData;
        this.showName = this.extraData;
    },
    methods: {
        ...mapActions("admin", ["getServiceConfiguration", "deleteServiceConfig"]),
        action(action) {
            if (action === "save") {
                if (this.checkMandatory()) {
                    const payload = {
                        fileScanning: {
                            serviceName: this.scanningService.serviceName,
                            passkey: this.scanningService.passKey,
                            settings: this.serviceConfiguration
                        }

                    };
                    this.$emit("save", payload);
                    this.addService = false;
                    this.showName = true;
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("admin.messagingCom.fileScanningSaved"),
                        timeout: 500
                    });
                }
            } else if (action === "close") {
                if (this.isDirty()) {
                    this.warningDialog = true;
                } else {
                    this.addService = false;
                }
            }
        },
        closeWithoutSaving() {
            this.addService = false;
            this.warningDialog = false;
            this.serviceConfiguration = this.serviceConfigurationCopy;
            this.scanningService = this.scanningServiceCopy;
            if (!this.scanningService) {
                this.$emit("closeToggle");
            }
        },
        checkMandatory() {
            let noError = true;
            Object.keys(this.requiredFields).forEach(key => {
                const found = Object.keys(this.serviceConfiguration).find(elem => elem === key);
                if (found && !this.serviceConfiguration[key]) {
                    this.$refs[key][0].error = true;
                    noError = false;
                } else if (this.$refs[key][0].error && found && this.serviceConfiguration[key]) {
                    this.$refs[key][0].error = false;
                }
            });
            return noError;
        },
        inputChanged(value, key) {
            this.serviceConfiguration[key] = value.target.value;
        },
        clearEvt(key) {
            this.serviceConfiguration[key] = "";
        },
        getScanningService() {
            const regex = /^[A-Za-z0-9-.]+$/;
            this.serviceNameErr = !regex.test(this.scanningService.serviceName);
            if (!this.serviceNameErr) {
                this.getServiceConfiguration(this.scanningService).then(data => {
                    if (data && data.data) {
                        this.serviceConfiguration = { ...data.data.mandatory, ...data.data.optional };
                        this.requiredFields = data.data.mandatory;
                    }
                });
                this.saveDisabled = false;
            }
        },
        openModal() {
            this.addService = true;
            if (this.extraData) {
                this.editMode = true;
                this.scanningService.serviceName = this.extraData.fileScanning.serviceName || "";
                this.scanningService.passKey = this.extraData.fileScanning.passkey || "";
                this.serviceConfiguration = this.extraData.fileScanning.settings || {};
            }
            this.scanningServiceCopy = JSON.parse(JSON.stringify(this.scanningService));
            this.serviceConfigurationCopy = JSON.parse(JSON.stringify(this.serviceConfiguration));
        },
        isDirty() {
            return JSON.stringify(this.scanningService) !== JSON.stringify(this.scanningServiceCopy)
            || JSON.stringify(this.serviceConfiguration) !== JSON.stringify(this.serviceConfigurationCopy);
        },

        deleteService() {
            this.showDialogRemove = true;
        },
        actionRemoveData() {
            if (this.fileId) {
                this.deleteServiceConfig(this.fileId).then(() => {
                    this.$emit("closeToggle");
                });
            }
        }

    }
};
